//import Groups from './screens/index.vue';
const Groups = () => import('./screens/index.vue')

import { checkUserPermissions } from '@/services/auth';
import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';

const groupsRoutes = [];

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.GROUP_VIEW,
    PERMISSIONS_KEYS.GROUP_INSERT,
    PERMISSIONS_KEYS.GROUP_EDIT,
    PERMISSIONS_KEYS.GROUP_DELETE,
  ])
) {
  groupsRoutes.push({
    path: '/regras-da-prescricao/grupos',
    name: 'Cadastro / Consulta|Grupo/Subgrupo Produto',
    component: Groups,
    meta: {
      icon: 'fa-prescription-bottle',
      requiresAuth: true,
    },
  });
}

export { groupsRoutes };
